import { useParams, useNavigate, useLocation, useOutletContext } from "react-router-dom";
import { useEffect, useRef, useState, useMemo } from "react";
import { useDispatch } from 'react-redux';
import Timer from "../components/global/Timer.jsx";
import Ballon from "../components/global/animations/Ballon.jsx";
import { Ball } from "../components/global/animations/Ball.jsx";
import Navbar from "../components/global/Navbar/Navbar";
import { Settings } from "../components/global/Navbar/Settings";
import { Strike } from "../components/global/Navbar/Strike";
import { Gift } from "../components/global/Navbar/Gift";
import { Avatar } from "../components/global/Profile/Avatar";
import { Score } from "../components/global/Score";
import TopBar from "../components/global/TopBar.jsx";
import { Levels } from "../components/global/Levels.jsx";
import GameResults from "../components/global/GameResults.jsx";
import { GameTiming } from "../components/global/GameTiming.jsx";
import { BigCloudIcon, IconRainbow, IconUserImages, CloudIcon, IconUserChristmasImages } from "../components/index.js";
import { data } from '../assets/data';
import { useCallback } from "react";
import { createStorage } from '../hooks/useStorage';
import { checkChristmas } from "../hooks/useCheckChristmas";
import { Subscription } from "../components/global/Subscription/Subscription";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import { Outlet } from "react-router-dom";
import { IconGift } from "../components/elements/Icon";


import TopScoresTable from "./TopScoresTable.jsx";
import {
    updateGift,
    updateSelectedProfile,
    addGift
} from '../redux/features/userSlice';

export default function GameZone() {
    createStorage();
    const dispatch = useDispatch();
    let { name, gameName } = useParams();
    if (!name) {
        name = localStorage.getItem(name)
        gameName = localStorage.getItem(gameName)
    }
    const location = useLocation();
    const isLeaderboard = location.pathname.includes("leaderboard");
    const isGameResult = location.pathname.includes("gameresult");
    const { leftBarClicked, navBarClicked, handleAnimatedGiftClick, days, selectedProfile } = useOutletContext();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openScore, setOpenScore] = useState(false);
    const [strike, setStrike] = useState(false);
    const [gift, setGift] = useState(false);
    const [openAvatar, setOpenAvatar] = useState(false);
    const [avatar, setAvatar] = useState([]);
    const [rightAnswers, setRightAnswers] = useState(0);
    const [backgroundMusic, setBackgroundMusic] = useState(JSON.parse(localStorage.getItem("backgroundMusic")));
    const [sound, setSound] = useState(JSON.parse(localStorage.getItem("sound")));
    const [hint, setHint] = useState(true);
    const [isGiftFlying, setIsGiftFlying] = useState(false);

    const h = window.innerHeight;
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    const { t } = useTranslation();


    const giftPosition = useMemo(() => {
        const isLeft = Math.random() < 0.5;
        const top = Math.random() < 0.5 ? "40%" : "70%";
        return {
            left: isLeft ? "90%" : undefined,
            right: isLeft ? undefined : "90%",
            top,
        };
    }, []);

    /*
 const lastCollected = localStorage.getItem("animatedGiftCollectedDate");
        if (!lastCollected) return true;

        const today = new Date();
        const last = new Date(lastCollected);

        const sameDay =
            today.getDate() === last.getDate() &&
            today.getMonth() === last.getMonth() &&
            today.getFullYear() === last.getFullYear();

        return !sameDay;
    */

    const handleResize = () => {
        setScreenSize({
            width: window.innerWidth,
            height: window.innerHeight,
        });
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const [isSettingsOpen, setIsSettingsOpen] = useState(() => {
        const storedIsOpen = localStorage.getItem("leftBarIsOpen");
        return storedIsOpen ? JSON.parse(storedIsOpen) : false;
    });
    useEffect(() => {
        const handleLeftBarIsOpenChange = () => {
            const storedIsOpen = localStorage.getItem("leftBarIsOpen");
            setIsSettingsOpen(storedIsOpen ? JSON.parse(storedIsOpen) : false);
        };
        window.addEventListener("leftBarIsOpenChange", handleLeftBarIsOpenChange);
        return () => {
            window.removeEventListener("leftBarIsOpenChange", handleLeftBarIsOpenChange);
        };
    }, []);

    const [isTopBarOpen, setIsTopBarOpen] = useState(() => {
        const storedIsOpen = localStorage.getItem("topBarIsOpen");
        return storedIsOpen ? JSON.parse(storedIsOpen) : false;
    });


    useEffect(() => {
        const handleTopBarIsOpenChange = () => {
            const storedIsOpen = localStorage.getItem("topBarIsOpen");
            setIsTopBarOpen(storedIsOpen ? JSON.parse(storedIsOpen) : false);
        };
        window.addEventListener("topBarIsOpenChange", handleTopBarIsOpenChange);
        return () => {
            window.removeEventListener("topBarIsOpenChange", handleTopBarIsOpenChange);
        };
    }, []);

    const [coming, setComing] = useState(() => localStorage.getItem("coming") === "true");

    useEffect(() => {
        const handleStorageChange = () => {
            setComing(localStorage.getItem("coming") === "true");
        };
        window.addEventListener("storage", handleStorageChange);
        return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    if (name === undefined) {
        name = localStorage.getItem('name')
    }

    const selectedGame = useMemo(() => {
        return data[name].find((item) => item.name === gameName)
    });

    const gameindex = useMemo(() => {
        return data[name].findIndex((item) => item.name === gameName)
    });
    const Component = selectedGame ? selectedGame.game : '';
    const [levelName, setLevelname] = useState("");
    const [sort, setSort] = useState(1);
    const [rotate, setRotate] = useState(false);

    const [startTimer, setStartTimer] = useState(false); //for timer component countdown 3-2-1
    //const [timerStorage, setTimerStorage] = useState(false);
    const timerStorage = useRef();
    const [stopTimer, setStopTimer] = useState(true); //timer component working
    const [timerResult, setTimerResult] = useState({ right: 0, wrong: 0 })


    useEffect(() => {
        setLevelname("");
        setStartTimer(false);
        setRightAnswers(0);
        setStopTimer(true);
        setTimerResult({ right: 0, wrong: 0 });
        //timerStorage.current = false;
        if (openScore) {
            setOpenScore(false);
        }
    }, [gameName]);


    const subscription = useSelector(state => state.user.subscription);

    const TimerComponent = () => {
        if (gameName && selectedGame.level && levelName || gameName && !selectedGame.level) {
            return <Timer
                stopTimer={stopTimer}
                subscription={subscription}
                openScore={openScore}
                level={levelName}
                timerResult={timerResult}
                timerStorage={timerStorage.current}
                handleOpenScore={() => setOpenScore(!openScore)}
                timer={selectedGame ? selectedGame.timer : null}
                result={selectedGame ? selectedGame.result : null}
                price={selectedGame ? selectedGame.price : null}
            />
        }
        if (gameName && selectedGame.level && !levelName || !gameName) return "";
    }
    //prevent gamecomponent from additional renders
    const handleUpdateProgress = useCallback(() => {
        setRightAnswers(prev => prev + 1);
    }, [rightAnswers]);
    const handleOpenScore = useCallback(() => {
        setOpenScore(!openScore);
    }, [openScore]);
    const handleTimer = useCallback(() => {
        setStopTimer(true);
        timerStorage.current = true;
    }, []);

    const handleTimerResult = (resultVal) => {
        if (selectedGame?.result) {
            if (resultVal) {
                setTimerResult({ ...timerResult, right: timerResult.right + 1 })
            } else {
                setTimerResult({ ...timerResult, wrong: timerResult.wrong + 1 })
            }
        }
    }

    const GameComponent = () => {
        if (data[name].length) {
            if (gameName && selectedGame?.level && levelName || gameName && !selectedGame?.level) {
                return <Component
                    subscription={subscription}
                    start={levelName}
                    answerSound={sound}
                    state={isSettingsOpen || isTopBarOpen}
                    handleUpdateProgress={handleUpdateProgress}
                    count={selectedGame ? selectedGame.cycle : 0}
                    handleOpenScore={handleOpenScore}
                    handleTimer={handleTimer}
                    handleTimerResult={handleTimerResult}
                    update={selectedGame.level && stopTimer}
                    level={levelName}
                    sort={sort}
                    hint={hint}
                    rotate={rotate}
                    point={selectedGame?.point}
                    screenSize={screenSize}
                />
            }


            if ((gameName && selectedGame.level && !levelName || !gameName)) {
                //return <img className="w-[318px] lg:w-[498px] xl:w-[512px] h-[100%]" src="/backGrounds/game-bg.svg" />;
                return (
                    <div
                        className="absolute w-full min-h-[263px] aspect-[16/9] bg-cover bg-center flex justify-center"
                        style={{ backgroundImage: "url('/backGrounds/homeSvgs.svg')" }}
                    >
                        <img className="w-[213px] h-[60px] md:w-[301.5px] md:h-[80px] xl:w-[537px] xl:h-[131.5px] lg:w-[442px] lg:h-[101.5px]"
                            src="/backGrounds/welcome_message.png" alt="Welcome" />
                    </div>

                );
            }

        } else {
            return '';
        }

    }



    const containerRef = useRef(null);
    useEffect(() => {
        if (screenSize.width < 1024) {
            containerRef.current.style.width = "100%";
        } else {
            if (screenSize.width >= 1024 && screenSize.width < 1440) {
                var delta = (isSettingsOpen ? 207 : 24);
            }
            if (screenSize.width >= 1440 && screenSize.width < 1920) {
                var delta = (isSettingsOpen ? 222 : 34);
            }
            if (screenSize.width >= 1920) {
                var delta = isSettingsOpen ? 328 : 34;
            }
            containerRef.current.style.width = screenSize.width - delta + "px";
        }

    }, [screenSize, isSettingsOpen]);

    const [openSubscription, setOpenSubscription] = useState(false);
    const [subscriptionType, setSubscriptionType] = useState("");

    const handleSubscription = (type, state) => {
        if (!state) {
            setOpenSubscription(!openSubscription);
        }
        setSubscriptionType(type);
    }


    /////////
    const [showModal_b, setshowModal_b] = useState(false);
    const [showModal_g, setshowModal_g] = useState(false);
    const [currentItem, setCurrentItem] = useState(null);
    const [overLimit, setOverLimit] = useState(false);

    useEffect(() => {
        setshowModal_b(false)
        setshowModal_g(false)
    }, [leftBarClicked, navBarClicked]);
    /////
    useEffect(() => {
        const handler = (e) => {
            setCurrentItem(e.detail.itemName);
            setshowModal_b(true);
        };
        window.addEventListener("showModal_b", handler);
        return () => window.removeEventListener("showModal_b", handler);
    }, []);

    useEffect(() => {
        const handler = (e) => {
            setCurrentItem(e.detail.itemName);
            setOverLimit(e.detail.overLimit || false);
            setshowModal_g(true);
        };
        window.addEventListener("showModal_g", handler);
        return () => window.removeEventListener("showModal_g", handler);
    }, []);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        document.body.style.touchAction = "none";
        document.documentElement.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = "";
            document.body.style.touchAction = "";
            document.documentElement.style.overflow = "";
        };
    }, []);




    return (
        <div
            ref={containerRef}
            className="select-none flex w-full h-full md:w-auto overflow-hidden no-scrollbar flex-col items-center bg-cover bg-[url('/backGrounds/home.svg')] z-0 relative">
            {openSubscription && <Subscription handleSubscription={(type, state) => handleSubscription(type, state)} subscriptionType={subscriptionType} screenSize={screenSize} />}
            {/* open && <Settings
                hint={hint}
                backgroundMusic={backgroundMusic}
                sound={sound}
                handleSubscription={(type) => handleSubscription(type)}
                handleBackgroundMusic={() => {
                    setBackgroundMusic(!backgroundMusic);
                    localStorage.setItem("backgroundMusic", !backgroundMusic);
                }}
                handleSound={() => {
                    setSound(!sound);
                    localStorage.setItem("sound", !sound);
                }}
                handleOpen={(hintOn) => {
                    setOpen(!open);
                    setHint(hintOn);
                }}
            />
            */}

            {/* strike && (
                <Strike onClose={() => setStrike(false)} />
            ) */}

            {/* gift && (
                <Gift onClose={() => setGift(false)} />
            ) */}


            {/* openAvatar && <Avatar
                avatars={avatar}
                subscription={subscription}
                handleSubscription={(type) => handleSubscription(type)}
                handleAvatar={() => {
                    setOpenAvatar(false);
                }}
                handleOpenAvatar={() => {
                    setOpenAvatar(!openAvatar);
                }}
            /> */}
            {openScore && <Score subscription={subscription} selectedGame={selectedGame} handleOpenScore={() => {
                setOpenScore(!openScore);
                setRightAnswers(0);
                setLevelname("");
                setStartTimer(false);
                setRightAnswers(0);
                setStopTimer(true);
                timerStorage.current = false;
                return navigate(`/games/${name}`);
            }}
                handleRefresh={() => {
                    if (subscription) {
                        setOpenScore(!openScore);
                        navigate(`/games/${name}/${gameName}`);
                        setStartTimer(true);
                        setRightAnswers(0);
                        setStopTimer(true);
                        timerStorage.current = false;
                    } else {
                        navigate(`/games/${name}`);
                        setOpenScore(!openScore);
                        setOpenSubscription(true);
                    }
                }}
                level={levelName}
            />}
            {/* <Navbar
                refresh={open}
                subscription={subscription}
                sound={sound}
                backgroundMusic={backgroundMusic}
                screenSize={screenSize}
                rightAnswers={rightAnswers}
                handleOpenAvatar={() => setOpenAvatar(!openAvatar)}
                count={selectedGame ? selectedGame.cycle : 0}
                point={typeof (selectedGame?.point) === "object" ? selectedGame?.point[levelName] : selectedGame?.point}
                handleBackgroundMusic={() => {
                    setBackgroundMusic(!backgroundMusic);
                    localStorage.setItem("backgroundMusic", !backgroundMusic);
                }}
                handleSound={() => {
                    setSound(!sound);
                    localStorage.setItem("sound", !sound);
                }}
                handleOpen={() => setOpen(!open)}
                level={levelName}
                topButtonRef={toggleRef}
                handleStrike={() => setStrike(!strike)}
                handleGift={() => setGift(!gift)}
            /> */}
            <TopBar
                subscription={subscription}
                handleSubscription={(type) => handleSubscription(type)}
                items={data[name]}
                gameindex={gameindex}
                level={levelName}
                screen={screenSize}
                days={days}
            />

            {showModal_b && (
                <div
                    onClick={() => { setshowModal_b(false); setCurrentItem(null); }}
                    className="w-full h-full absolute z-[60] bg-bgBlack/30 flex justify-center items-center"
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="w-[244px] md:w-[347px] lg:w-[401px] rounded-[19px] border-[3px] md:border-[4px] border-[#7743BA] bg-[#FFF] 
             p-4 md:p-6 lg:p-8 flex flex-col justify-start"
                    >
                        <div className="w-[184px] md:w-[316px] mx-auto font-fredokaOne">

                            <p className="mt-[16px] lg:mt-[34px] md:text-[16px] text-[14px] text-[#4B96C9] text-center md:w-[219px] md:mx-auto lg:text-[20px]">
                                {t("gift_text2")}
                            </p>
                            <div className="mt-[23px] md:mt-[34px] flex justify-around md:w-[215px] lg:w-[273px] md:justify-between md:mx-auto">
                                <button
                                    onClick={() => {
                                        const gameStorage = JSON.parse(localStorage.getItem('playedGames')) || {};
                                        const userGames = gameStorage[name] || [];
                                        const gameIndex = userGames.findIndex(g => g.name === currentItem);

                                        if (gameIndex === -1) {
                                            userGames.push({
                                                name: currentItem,
                                                count: 0,
                                                point: 0,
                                                doubleScore: 1,
                                                giftClicked: 0,
                                                dbsc: 1,
                                            });
                                        } else {
                                            userGames[gameIndex].doubleScore = 1;
                                            userGames[gameIndex].dbsc = 1;
                                        }

                                        gameStorage[name] = userGames;
                                        localStorage.setItem('playedGames', JSON.stringify(gameStorage));
                                        localStorage.setItem("days", (Number(localStorage.getItem("days")) || 0) - 1);

                                        setshowModal_b(false);
                                        setCurrentItem(null);

                                        //setUpdate(u => !u);
                                    }}
                                    className="w-[61px] h-[26px] md:w-[83px] md:h-[28px] lg:text-[20px] lg:w-[102px] lg:h-[34px] border-[2px] rounded-[7px] text-[#fff] text-center text-[14px] md:text-[16px] border-[#1F6645] bg-[#39BA7E]"
                                >
                                    {t("yes")}
                                </button>
                                <button
                                    onClick={() => {
                                        setshowModal_b(false);
                                        setCurrentItem(null);
                                    }}
                                    className="w-[61px] h-[26px] md:w-[83px] md:h-[28px] lg:text-[20px] lg:w-[102px] lg:h-[34px] border-[2px] rounded-[7px] text-[#fff] text-center text-[14px] md:text-[16px] border-[#C11111] bg-[#E84620]"
                                >
                                    {t("no")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}






            {showModal_g && (
                <div
                    onClick={() => { setshowModal_g(false); setCurrentItem(null); }}
                    className="w-full h-full absolute z-[60] bg-bgBlack/30 flex justify-center items-center"
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        className="w-[244px] md:w-[347px] lg:w-[401px] rounded-[19px] border-[3px] md:border-[4px] border-[#7743BA] bg-[#FFF] 
             p-4 md:p-6 lg:p-8 flex flex-col justify-start"
                    >
                        <div className="w-[184px] md:w-[316px] mx-auto font-fredokaOne">

                            <p className="mt-[16px] lg:mt-[34px] md:text-[16px] text-[14px] text-[#4B96C9] text-center md:w-[219px] md:mx-auto lg:text-[20px]">
                                {t("gift_text")}
                            </p>
                            <div className="mt-[23px] md:mt-[34px] flex justify-around md:w-[215px] lg:w-[273px] md:justify-between md:mx-auto">
                                <button
                                    onClick={async () => {
                                        const giftCount = 1;
                                        const storedDays = Number(localStorage.getItem("days")) || 0;


                                        const gameStorage = JSON.parse(localStorage.getItem("playedGames")) || {};
                                        const userGames = gameStorage[name] || [];
                                        const gameIndex = userGames.findIndex(g => g.name === currentItem);

                                        if (gameIndex === -1) {
                                            userGames.push({
                                                name: currentItem,
                                                count: 0,
                                                point: 0,
                                                doubleScore: 0,
                                                dbsc: 0,
                                                giftClicked: overLimit ? 1 : 0,
                                            });
                                        } else {
                                            userGames[gameIndex].count = 0;
                                            userGames[gameIndex].doubleScore = 0;
                                            userGames[gameIndex].dbsc = 0;

                                            if (overLimit) {
                                                userGames[gameIndex].giftClicked = 1;
                                            }
                                        }

                                        gameStorage[name] = userGames;
                                        localStorage.setItem("playedGames", JSON.stringify(gameStorage));


                                        if (selectedProfile?._id) {
                                            try {
                                                await dispatch(
                                                    updateGift({
                                                        _id: selectedProfile._id,
                                                        count: giftCount,
                                                    })
                                                ).unwrap();

                                                dispatch(
                                                    updateSelectedProfile({
                                                        ...selectedProfile,
                                                        gift: Math.max(0, selectedProfile.gift - giftCount),
                                                    })
                                                );
                                            } catch (err) {
                                                console.error(err);
                                                return;
                                            }
                                        }


                                        const newDays = Math.max(0, storedDays - giftCount);
                                        localStorage.setItem("days", newDays);


                                        setshowModal_g(false);
                                        setCurrentItem(null);
                                    }}
                                    className="w-[61px] h-[26px] md:w-[83px] md:h-[28px] lg:text-[20px] lg:w-[102px] lg:h-[34px] border-[2px] rounded-[7px] text-[#fff] text-center text-[14px] md:text-[16px] border-[#1F6645] bg-[#39BA7E]"
                                >
                                    {t("yes")}
                                </button>


                                <button
                                    onClick={() => {
                                        setshowModal_g(false);
                                        setCurrentItem(null);
                                    }}
                                    className="w-[61px] h-[26px] md:w-[83px] md:h-[28px] lg:text-[20px] lg:w-[102px] lg:h-[34px] border-[2px] rounded-[7px] text-[#fff] text-center text-[14px] md:text-[16px] border-[#C11111] bg-[#E84620]"
                                >
                                    {t("no")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}



            {!openAvatar && (<div
                className={`${(isSettingsOpen || isTopBarOpen)
                    ? 'flex items-center justify-center px-[12vw] py-[7vh] '
                    : 'flex items-center justify-center px-[15vw] py-[10vh]'
                    } ${data[name].length === 0 ? 'overflow-hidden' : ''} gamezone flex relative m-auto z-[10] rounded-[13px] ${checkChristmas() ? "bg-[url('/backGrounds/christmassecondarybackground.svg')] bg-cover" : "bg-[url('/backGrounds/secondarybackground.svg')]  bg-contain"} xl:bg-cover shadow-[1px_1px_24px_7px_rgba(220,_220,_221,_0.31)]`}
                style={{ backgroundPosition: 'center center' }}
            >
                {isLeaderboard && (
                    <div
                        className={`
                                    absolute inset-0
                                    z-[10000]
                                    flex items-center justify-center
                                    rounded-[14px]
                                    ${checkChristmas()
                                ? "bg-[url('/backGrounds/christmassecondarybackground.svg')] bg-cover"
                                : "bg-[url('/backGrounds/secondarybackground.svg')] bg-cover"}
                                `}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <TopScoresTable />
                    </div>
                )}


                {selectedGame?.level && !levelName && <Levels
                    state={isSettingsOpen || isTopBarOpen}
                    handleChange={(name, sort, rotate) => {
                        setLevelname(name);
                        setStartTimer(true);
                        setSort(sort);
                        setRotate(rotate);
                        localStorage.setItem('rotate', JSON.stringify(rotate));
                    }}
                />}
                {
                    isGameResult &&
                    <div
                        className={`
                                        absolute inset-0
                                        z-[10000]
                                        flex items-center justify-center
                                        rounded-[14px]
                                        ${checkChristmas()
                                ? "bg-[url('/backGrounds/christmassecondarybackground.svg')] bg-cover"
                                : "bg-[url('/backGrounds/secondarybackground.svg')] bg-cover"}
                                    `}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <GameResults state={isSettingsOpen || isTopBarOpen} subscription={subscription} />
                    </div>
                }

                {startTimer && selectedGame && selectedGame.timer && <GameTiming handleTimer={() => {
                    setStartTimer(false);
                    setStopTimer(false);
                }} />}

                {!(gameName && selectedGame.level && !levelName || !gameName) && <IconRainbow className={'absolute bottom-0 left-[10%] '} />}
                {data[name].length ? <BigCloudIcon
                    className={`hidden md:block ${(isSettingsOpen || isTopBarOpen) ? 'h-[266px] md:h-[292px] lg:h-[370px] lg2:h-[412px] xl:h-[454px]' : 'h-[266px] md:h-[360px] lg:h-[452px] lg2:h-[498px] xl:h-[544px]'} absolute right-[50%] top-[50%] -translate-y-1/2 translate-x-1/2 `} /> : <CloudIcon
                    className={`${(isSettingsOpen || isTopBarOpen) ? 'top-[0px] right-[50px] md:top-[0px] md:right-[50px] lg:top-[20px] xl:top-[48px] lg:right-[180px] xl:right-[330px]' : 'top-[0px] right-[40px] md:top-[40px] md:right-[150px] lg:top-[80px] lg:right-[300px] xl:top-[120px] xl:right-[460px]'} absolute`}
                />}
                <div
                    className={`${(isSettingsOpen || isTopBarOpen)
                        ? 'h-[266px] w-[425px] md:h-[292px] md:w-[439px] lg:h-[370px] lg:w-[590px] xl:h-[454px] xl:w-[768px]'
                        : 'h-[266px] w-[425px] md:h-[360px] md:w-[576px] lg:h-[452px] lg:w-[723px] xl:h-[544px] xl:w-[910px]'
                        } game flex items-center overflow-hidden justify-center rounded-[14px] relative`}
                >
                    {GameComponent()}
                </div>
                <Ballon color={'green'} point={typeof (selectedGame?.point) === "object" ? selectedGame?.point[levelName] : selectedGame?.point}
                />
                {data[name].length === 0 ? <Ballon color={'red'} /> : ''}
                {selectedGame?.level ? selectedGame?.name == 'memory' || selectedGame?.name == 'classic' ? levelName === 'beginner' ? '' : TimerComponent() : TimerComponent() : ''}

                {!(gameName && selectedGame.level && !levelName || !gameName) &&
                    (checkChristmas() ? (
                        <IconUserChristmasImages
                            user={data[name].length ? (selectedGame ? selectedGame.userImage : 'avatar 10_all') : 'avatar 5_all'}
                            className={`${data[name].length === 0
                                ? 'w-[186px] h-[248px] absolute right-[50%] top-[50%] -translate-y-1/2 translate-x-1/2'
                                : 'absolute -right-[7%] xl:-bottom-[10%] -bottom-[8%] lg:-bottom-[5%] h-1/2 z-[100000]'
                                }`}
                        />
                    ) : (
                        <IconUserImages
                            user={data[name].length ? (selectedGame ? selectedGame.userImage : 'avatar 10_all') : 'avatar 5_all'}
                            className={`${data[name].length === 0
                                ? 'w-[186px] h-[248px] absolute right-[50%] top-[50%] -translate-y-1/2 translate-x-1/2'
                                : 'absolute -right-[7%] xl:-bottom-[10%] -bottom-[8%] lg:-bottom-[5%] h-1/2 z-[100000]'
                                }`}
                        />
                    ))}


                {data[name].length === 0 ? <div
                    className={` ${(isSettingsOpen || isTopBarOpen) ? 'bottom-[10%] md:bottom-[12%] lg:bottom-[17%] xl:bottom-[21%]' : 'bottom-[13%] md:bottom-[20%] lg:bottom-[24%] xl:bottom-[26.5%]'} absolute  font-righteous text-[30px] text-[#313131]`}>
                    under construction
                </div> : ''}
            </div>)}
            {/* <Ball state={isTopBarOpen} screen={screenSize} /> */}
        </div>
    );
}
